import { defineStore } from 'pinia';
import { User } from '../entities/user';

export const useCreateUserDialog = defineStore('createUserDialog', {
	state: () => ({
		isOpen: false,
		loading: false,
		email: '',
		fullName: '',
	}),
	actions: {
		async open() {
			this.fullName = '';
			this.email = '';
			this.isOpen = true;
		},
		async createUser({ role_ids } = {}) {
			this.loading = true;
			try {
				const payload = { email: this.email, full_name: this.fullName };
				if (role_ids) payload.role_ids = role_ids;
				await User.createUser(payload);
			} finally {
				this.loading = false;
			}
		},
	},
});
